import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/warning.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "60",
    width: "60"
  })
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center" }
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = { class: "w-full mt-10" }
const _hoisted_7 = {
  key: 0,
  class: "input-group grid grid-cols-2 items-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Họ và Tên ", -1)
const _hoisted_9 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_10 = {
  key: 1,
  class: "input-group grid grid-cols-2 items-center mt-8"
}
const _hoisted_11 = { class: "input-group__label text-neutral-500 font-normal" }
const _hoisted_12 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_13 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " Bạn có muốn xoá " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " khỏi danh sách dạy học sinh này? ", 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.terminology('teacher')) + " bị xoá sẽ không thể xem thông tin và báo cáo kết quả buổi học cho học sinh này nữa. ", 1),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.popupData.studentName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.popupData.studentName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.popupData.teacherName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, " Tên " + _toDisplayString(_ctx.$filters.terminology('teacher')), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.popupData.teacherName), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Thoát "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Xác nhận ")
    ])
  ]))
}